import {
  UPLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS,
  UPLOADSAMPLEFILEOFCURRENCYRATE_FAILED,
  RESET_UPLOADSAMPLEFILEOFCURRENCYRATE,
  LOADING_UPLOADSAMPLEFILEOFCURRENCYRATE,
  NETWORK_ERROR_UPLOADSAMPLEFILEOFCURRENCYRATE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPLOADSAMPLEFILEOFCURRENCYRATE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPLOADSAMPLEFILEOFCURRENCYRATE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPLOADSAMPLEFILEOFCURRENCYRATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPLOADSAMPLEFILEOFCURRENCYRATE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPLOADSAMPLEFILEOFCURRENCYRATE:
      return (state = initialState);
    default:
      return state;
  }
};
